module.exports = __webpack_public_path__ + "media/images/logos/logo_big-28a95cbcb3d4e74e683b8bff0e20f1ad.svg";